import Oidc from 'oidc-client';
import * as Config from 'common/config.js';

class SecurityServices {
  static async loginAsync() {
    const userManager = new Oidc.UserManager(Config.oidcConfig);
    const user = await userManager.getUser();
    if (!user || user.expired) {
      userManager.signinRedirect();
    }
    return user;
  }

  static userHasAllPermissions(userPermissions, ...permissions) {
    const isAllowed = permissions.every((p) => userPermissions.indexOf(p) > -1);
    return isAllowed;
  }

  static userHasSomePermissions(userPermissions, ...permissions) {
    const isAllowed = permissions.some((p) => userPermissions.indexOf(p) > -1);
    return isAllowed;
  }

  static async getUserAsync() {
    return await this.loginAsync();
  }

  static signOut(idToken) {
    const userManager = new Oidc.UserManager(Config.oidcConfig);
    userManager.signoutRedirect();
  }

  static signinSilent() {
    const userManager = new Oidc.UserManager(Config.oidcConfig);
    return userManager.signinSilent();
  }
}

export default SecurityServices;
